
import { Amplify } from "aws-amplify";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from './App';
import awsconfig from "./aws-exports";
import ActivationPage from "./components/Activation/ActivationPage";
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import ErrorPage from './pages/ErrorPage/ErrorPage';
import Logout from './pages/Logout/Logout';
import RedirectPage from './pages/RedirectPage/RedirectPage';
import store from './redux/store';
import * as serviceWorker from "./serviceWorker";
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import "./index.css";
import SpinnerPage from "./components/SpinnerPage/SpinnerPage";
import ConfirmPassword from "./components/ConfirmPassword/ConfirmPassword";
import SessionStorage from "./utilities/tokensStorage";
import { getCookie } from './components/LandingPage/helpers/cookieHelper';
import TagManager from 'react-gtm-module';
//DataDog config
import { initializeDatadogLogging, logMessage } from "./utilities/datadogLogger";

const tagManagerArgs = {
	gtmId: process.env.REACT_APP_GTM_ID,
};

TagManager.initialize(tagManagerArgs);

const config = require("Config");

let amplifyConfig = {
	...awsconfig,
	Auth: {
		storage: SessionStorage,
		// OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
		authenticationFlowType: config.authenticationFlowType !== undefined ? config.authenticationFlowType : "USER_SRP_AUTH",
	},
};

// If we have in parameter that means start a PKCE or Implict flow
// We switch the clientId to submit the one from the client website
let queryStringParams = new URLSearchParams(window.location.search);
let clientId = queryStringParams.get("client_id");

if (queryStringParams.get("redirectUrl")) {
	sessionStorage.setItem("redirectUrl", queryStringParams.get("redirectUrl"))
}
if (queryStringParams.get('data')) {
	sessionStorage.setItem("data", queryStringParams.get('data'));
}
if (queryStringParams.get("logoutRedirectUrl")) {
	sessionStorage.setItem("logoutRedirectUrl", queryStringParams.get("logoutRedirectUrl"))
}


if (queryStringParams.get("authorize")) {
	let authorizeParam = queryStringParams.get("authorize")
	authorizeParam = authorizeParam.replace('AUTH_HOST', awsconfig.oauth.domain).replace('CLIENT_ID_VALUE', awsconfig.aws_user_pools_web_client_id);
	if (getCookie("auth_source") != null) {
		sessionStorage.setItem("authorize", authorizeParam.replace(' ', ''));
		window.location.href = `https://${awsconfig.oauth.domain}/logout?client_id=${awsconfig.aws_user_pools_web_client_id}&logout_uri=${encodeURIComponent(awsconfig.oauth.redirectSignOut)}`;
	} else {
		let customUrl = authorizeParam;
		if (queryStringParams.get("code"))
			customUrl = customUrl + '&code=' + queryStringParams.get("code");
		sessionStorage.setItem("showLoginLoader", true);
		if (customUrl.toLowerCase().includes('classlink') || customUrl.toLowerCase().includes('clever') || customUrl.toLowerCase().includes('gadoe') 
			|| customUrl.toLowerCase().includes('gg4l') || customUrl.toLowerCase().includes('skyward') || customUrl.toLowerCase().includes('sky-'))
			sessionStorage.setItem("authorize", authorizeParam.replace(' ', ''));
		else
			window.location.href = customUrl.replace(' ', '');
	}
}

try {
	if (queryStringParams.get("token") && window.location.href.includes("confirmPassword") === false)
		sessionStorage.setItem("activationToken", queryStringParams.get("token"))

	if (queryStringParams.get("inviteCode"))
		sessionStorage.setItem("inviteCode", queryStringParams.get("inviteCode"))

	if (clientId) {
		// We save the client ID, our Amplify auth will be based on that one
		localStorage.setItem("client-id", clientId);
	} else {
		// If there is no client-Id in query, we set back the last one used for login
		// it may be undefined if we never logged in
		clientId = localStorage.getItem("client-id");
	}
	if (clientId) {
		// We configure the Amplify Auth component in the context of using a client website client-id
		// if no clientId is found (direct login not from a client) the web client id of the broker will be used as default
		amplifyConfig.aws_user_pools_web_client_id = clientId;
		config.appClientId = amplifyConfig.aws_user_pools_web_client_id;
	}
} catch (e) {
	console.log(JSON.stringify(e));
}
/* FOR DATADOG */
const clientToken = awsconfig.datadogClientToken
const isProduction = awsconfig.isProduction

window.onerror = function (message, source, lineno, colno, error) {
	logMessage('Unhandled Error', 'error', {
		message,
		source,
		lineno,
		colno,
		error,
	});
};

window.onunhandledrejection = function (event) {
	logMessage('Unhandled Promise Rejection', 'error', {
		reason: event.reason,
	});
};
/* END FOR DATADOG*/

Amplify.configure(amplifyConfig);

/*
 * App Routing
 * With "ProtectedRoute" we redirect user to Login if they are not signed in and _
 * we redirect user to Terms of Service (ToS) if a user not accepted the current ToS
 * 
 * If we route to a none existing page we will redirect to the "ErrorPage"
 */
const container = document.getElementById('root')
const root = createRoot(container);
initializeDatadogLogging(isProduction, clientToken);
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<Authenticator.Provider>
				<BrowserRouter>
					<Routes>
						<Route exact path="/activation" element={
							<ProtectedRoute>
								<ActivationPage />
							</ProtectedRoute>
						} />
						<Route exact path="/launch" element={
							<ProtectedRoute>
								<RedirectPage />
							</ProtectedRoute>
						} />
						<Route exact path="/loading" element={<SpinnerPage />} />
						<Route exact path="/logout" element={<Logout />} />
						<Route exact path="/sign_up" element={<App />} />
						<Route exact path="/resetPassword" element={<App />} />
						<Route exact path="/changePassword" element={<App />} />
						<Route exact path="/confirmPassword" element={<ConfirmPassword />} />
						<Route exact path="/sign-up" element={<App />} />
						<Route exact path="/" element={<App />} />

						<Route path="*" element={<ErrorPage />} />
					</Routes>
				</BrowserRouter>
			</Authenticator.Provider>
		</Provider>
	</React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://create-react-app.dev/docs/making-a-progressive-web-app
serviceWorker.unregister();
